import React from "react";
import "./about-us.css";

const AboutUsPage = () => {
  return (
    <section id="about-us" className="main-section">
      <div className="main-contents container">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-md-6 d-flex justify-content-center">
            <div className="left-section bg-img-left">
              <div className="centered-contents">
                <h2 className="main-content-title mb-4">
                  Built By People Who Ask Why
                  {/* <span className="decorate-text"> London, UK</span> */}
                </h2>

                <p className="about-quad-text">
                  Quad Theory Ltd started with people who were tired of building
                  software that looked good but failed in the real world. We
                  shared a common philosophy: Listen well, assume little, and
                  deliver what matters most. Today, we collaborate with growing
                  teams to develop their ideas into systems built to last, grow,
                  and help businesses for years to come.
                </p>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-md-6">
            <div className="right-section bg-img-right"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsPage;
